// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 815) return "static/chunks/815-5413169b6e5fa8c6.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"341":"b9b26c3f","538":"recorder","983":"profiler"}[chunkId] || chunkId) + "." + {"133":"6d020f307dbd7e58","341":"2c6dbd7c783c6675","377":"52adc775dbe58441","415":"67a6f87f942e05e5","538":"c9c3622d2fd64809","680":"95f34dc052d561cb","767":"f972996417007120","983":"74000e5117bfeb38"}[chunkId] + ".js";
};